export const profile = {
  name: "Pedro Monteiro",
  role: "Software Engineer",
  company: "Quorum Born IT",
  location: "Lisbon, Portugal",
  hometown: "Guarda, Portugal",
  email: "pmapm123@gmail.com",
  linkedin: "https://www.linkedin.com/in/pedromonteiro01/",
  github: "https://github.com/pedromonteiro01",
};

export const cvFiles = [
  { id: "pt", label: "cv_pt.pdf", desc: "Portuguese CV", path: "/files/Pedro_Monteiro_cv.pdf", size: "68K" },
  { id: "en", label: "cv_en.pdf", desc: "English CV", path: "/files/Pedro_Monteiro_en_cv.pdf", size: "66K" },
];

export const typedStack = [
  "Python", "Java", "C/C++", "HTML/CSS", "JavaScript", "ReactJS", "PHP",
  "Spring Boot", "Django", "C#", "ASP .NET Core 6", "SQL", "MySQL",
  "Docker", "Kubernetes", "Flutter", "Dart", "Nginx",
];

export const stats = [
  { id: 1, value: "100+", label: "repos created" },
  { id: 2, value: "2000+", label: "hours coding" },
  { id: 3, value: "3000+", label: "GitHub contributions" },
  { id: 4, value: "6+", label: "years of experience" },
];
